import React from 'react';

export const ConfirmationFinePrint = ({ ctaText, selectedPlan = {} }) => {
  const { duration, planPrice = '', planFrequencyText = '' } = selectedPlan;

  if (duration > 1) {
    return (
      <p className="finePrint">
        By clicking "{ctaText}", you are enrolling in automatic payments after your original subscription expires. Your
        subscription will automatically renew for additional one-year periods at the $64.99/yr (plus tax and fees where
        applicable) that will continue until you cancel. You can cancel at any time, effective at the end of the billing
        period. All sales are final, no refund or credits for partial months or years.
      </p>
    );
  }

  return (
    <p className="finePrint">
      By clicking "{ctaText}", you are enrolling in automatic payments of ${planPrice}/{planFrequencyText.trim()} (plus
      tax and fees where applicable) that will continue until you cancel. You can cancel at any time, effective at the
      end of the billing period. All sales are final, no refund or credits for partial months or years.
    </p>
  );
};
